var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLargeThumbnails({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h6.85714v6.85714h-6.85714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 9.14282h6.85714v6.85714h-6.85714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.14258 0h6.85714v6.85714h-6.85714z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m9.14258 9.14282h6.85714v6.85714h-6.85714z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLargeThumbnails);
export default __webpack_public_path__ + "static/media/large-thumbnails.5ecfe1753d07669d734d218612b5f7be.svg";
export { ForwardRef as ReactComponent };